import React, { createContext, useContext, useState, ReactNode } from "react";

export interface StatusMessage {
  title: string;
  message: string;
  isError: boolean;
  isOkButtonVisible: boolean;
}

export interface UseStatusMessageReturn {
  status: StatusMessage;
  setStatus: (patch: Partial<StatusMessage>) => void;
  clear: () => void;
}

const DEFAULT_STATUS: StatusMessage = {
  title: "",
  message: "",
  isError: false,
  isOkButtonVisible: false,
};

const StatusMessageContext = createContext<UseStatusMessageReturn | null>(null);

export const StatusMessageProvider = ({ children }: { children: ReactNode }) => {
  const [status, setStatusState] = useState<StatusMessage>(DEFAULT_STATUS);

  const setStatus = (patch: Partial<StatusMessage>) => {
    setStatusState((prev) => ({ ...prev, ...patch }));
  };

  const clear = () => {
    setStatusState(DEFAULT_STATUS);
  };

  return (
    <StatusMessageContext.Provider value={{ status, setStatus, clear }}>
      {children}
    </StatusMessageContext.Provider>
  );
};

export const useStatusMessage = (): UseStatusMessageReturn => {
  const ctx = useContext(StatusMessageContext);
  if (!ctx) {
    throw new Error("useStatusMessage must be used within StatusMessageProvider");
  }
  return ctx;
};
